export default __webpack_public_path__ + "static/media/eye.0cc1e91d.svg";